import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { listGroups, type GroupResponse } from '@api/groups';
import useAuth from '@contexts/useAuth';

const GROUPS_KEY = ['organization', 'groups'] as const;

export function useGroups(): UseQueryResult<GroupResponse[], Error> {
  const { user } = useAuth();
  const token = user?.token;
  const userId = user?.id;

  return useQuery<GroupResponse[], Error>({
    queryKey: [...GROUPS_KEY, userId],
    queryFn: async () => {
      if (!token) throw new Error('Not authenticated');
      return listGroups(token);
    },
    enabled: Boolean(token),
    staleTime: 60_000,
    retry: 1,
  });
}
